import {
  BasePaginateParamsSchema,
  BasePaginateResultSchema,
} from '@/api/common.ts'
import { z } from 'zod'

export const Sale1220SearchParamsSchema = z
  .object({
    partyId: z.string().optional(),
    code: z.string().optional(),
  })
  .merge(BasePaginateParamsSchema)
export type Sale1220SearchParams = z.infer<typeof Sale1220SearchParamsSchema>

export const Sale1220SearchResultModelSchema = z.object({
  id: z.number(),
  partyId: z.number().nullable(),
  itemId: z.number().nullable(),
  code: z.string().nullable(),
  name: z.string().nullable(),
})

export type Sale1220SearchResultModel = z.infer<
  typeof Sale1220SearchResultModelSchema
>

export const Sale1220SearchResultSchema = z
  .object({
    data: z.array(Sale1220SearchResultModelSchema),
  })
  .merge(BasePaginateResultSchema)

export type Sale1220SearchResult = z.infer<typeof Sale1220SearchResultSchema>
